type LinkedInOutlineIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const LinkedInOutlineIcon = (props: LinkedInOutlineIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.333 6.6665C14.6591 6.6665 15.9309 7.19329 16.8685 8.13097C17.8062 9.06865 18.333 10.3404 18.333 11.6665V17.4998H14.9997V11.6665C14.9997 11.2245 14.8241 10.8006 14.5115 10.488C14.199 10.1754 13.775 9.99984 13.333 9.99984C12.891 9.99984 12.4671 10.1754 12.1545 10.488C11.8419 10.8006 11.6663 11.2245 11.6663 11.6665V17.4998H8.33301V11.6665C8.33301 10.3404 8.85979 9.06865 9.79747 8.13097C10.7352 7.19329 12.0069 6.6665 13.333 6.6665V6.6665Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00033 7.5H1.66699V17.5H5.00033V7.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33366 4.99984C4.25413 4.99984 5.00033 4.25364 5.00033 3.33317C5.00033 2.4127 4.25413 1.6665 3.33366 1.6665C2.41318 1.6665 1.66699 2.4127 1.66699 3.33317C1.66699 4.25364 2.41318 4.99984 3.33366 4.99984Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
